import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FoirReportComponent } from './foir-report/foir-report.component';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { DsrReportComponent } from './dsr-report/dsr-report.component';
import { MassflowComponent } from './massflow/massflow.component';
import { TableComponent } from './table/table.component';
import { MatTableModule } from '@angular/material/table';
import { AppFilterPipeModule } from 'app/_filters/app.filter-pipe.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatsharedComponent } from './matshared/matshared.component';
import { NgxMatNativeDateModule, NgxMatDatetimePickerModule } from '@angular-material-components/datetime-picker';
import { MatChipsModule } from '@angular/material/chips';
import { VehicledetComponent } from './vehicledet/vehicledet.component';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatButtonToggleModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatRippleModule,
        MatSortModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatTooltipModule,

        MatMomentDateModule,
        MatDatepickerModule,
        MatChipsModule,
        MatTableModule,
        AppFilterPipeModule,
        DragDropModule,
        NgxMatDatetimePickerModule, NgxMatNativeDateModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatButtonToggleModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatRippleModule,
        MatSortModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatTooltipModule,

        MatMomentDateModule,
        MatDatepickerModule,
        FoirReportComponent,
        DsrReportComponent,
        VehicledetComponent,
        TableComponent,
        MatsharedComponent

    ],
    declarations: [
        FoirReportComponent,
        DsrReportComponent,
        MassflowComponent,
        TableComponent,
        MatsharedComponent,
        VehicledetComponent
    ]
})
export class SharedModule {
}
